<template>
  <div>
    <div class="pxkeji-right-box">
      <div class="search-box">
        <a-form class="ant-advanced-search-form">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="子站简称">
                <a-input placeholder="请输入" v-model="where.keyword.name" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="子站状态">
              <a-select placeholder="选择子站状态" v-model="where.keyword.status" allowClear>
                <a-select-option value="1">启用</a-select-option>
                <a-select-option value="0">禁用</a-select-option>
              </a-select>
            </a-form-item>
            </a-col>
            <a-col :span="6" :style="{ textAlign: 'left' }">
              <a-button type="primary" @click="searchList" style="margin-top: 5px;">搜索</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-row type="flex" justify="space-between">
        <a-col :span="18">
          <div class="table-box">
            <a-table :columns="list.columns" rowKey="id" :pagination="list.pagination"
              :rowSelection="{ type: 'checkbox', onChange: onRowChange, selectedRowKeys: selectRows }" @change="onChange"
              :dataSource="list.datas" :loading="isloading" :locale="{ emptyText: '暂无数据' }">
              <span slot="status" slot-scope="status">
                <a-tag v-if="status == 1" color="green">启用</a-tag>
                <a-tag v-else color="red">禁用</a-tag>
              </span>
            </a-table>
          </div>
        </a-col>
        <a-col :span="5">
          <div class="subsite-box">
            <div class="hearder">已选：<span>{{ selectRows.length }}</span>&nbsp;&nbsp;&nbsp;&nbsp;共：<span>{{ list.pagination.total }}</span></div>
            <div class="subsite-list">
              <a-list :data-source="choose.datas">
                <a-list-item slot="renderItem" slot-scope="item, index">
                  <span>{{ item.name }}</span>
                </a-list-item>
              </a-list>
            </div>
          </div>
          <!-- <a-table :dataSource="choose.datas" :columns="choose.columns" :locale="{emptyText:'暂无数据'}"/> -->
        </a-col>
      </a-row>

      <div class="but-box">
        <a-button type="primary" style="margin-top: 20px;" @click="confirmUpdate">确认选择</a-button>
      </div>
    </div>
  </div>
</template>
<script>
var that;
import Info from "./areaInfo.vue"; // 编辑

const columns = [
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "子站简称"
  },
  {
    dataIndex: "domain",
    key: "domain",
    align: "center",
    title: "域名",
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
];
const chooseColumns = [
  {
    dataIndex: "title",
    key: "title",
    align: "center",
    title: "站点简称"
  },
];

export default {
  name: "areaList",
  data() {
    return {
      expand: false, //高级搜索
      choose: {
        chooseColumns,
        datas: []

      },
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 1000 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          status: ""
        }
      },
      selectRows: [], //选中项编号
      selectRecord: [],//选择的站点
      isloading: false,
    };
  },
  components: {
    Info: Info,
  },
  mounted: function () {
    this.$nextTick(function () {
      that = this;
      that.selectRows = [];
      that.selectRecord = [];
      this.GetList();
    });
  },
  watch: {
    selectRows: function () {
    }
  },
  methods: {
    /**
     * 下一步
     */
    confirmUpdate() {
      if (this.selectRows.length == 0) {
        this.$message.error("请先选择站点");
        return;
      }
      this.$emit("confirm", { dataZones: this.selectRows })
    },

    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.$api.area
        .getAreaInfoPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.name,
          this.where.keyword.status
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys, e) {
      e.forEach(element => {
        that.selectRecord[element.id] = element;
      });

      var allSelectRecord = [];
      selectedRowKeys.forEach(id => {
        allSelectRecord.push(that.selectRecord[id]);
      })
      this.choose.datas = allSelectRecord;
      this.selectRows = selectedRowKeys;
    },

  }
};
</script>

<style>
.subsite-box {
  border: 1px solid #e9e9e9;
  height: 440px;

  .hearder {
    height: 52px;
    line-height: 52px;
    font-size: 14px;
    padding-left: 10px;
    font-weight: bold;
    background: #fafafa;
    border-bottom: 1px solid #e9e9e9;
  }

  .subsite-list {
    padding: 0 10px;
    height: 390px;
    overflow-y: auto;
  }
}

.search-box {
  height: 60px;
}

.table-box {
  max-height: 440px;
  overflow-y: scroll;
}

.but-box {
  height: 60px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

